const containerSettingsStored = JSON.parse(
  localStorage.getItem("containerSettingsStored") as string
);
const initialState = containerSettingsStored
  ? { containerSettings: containerSettingsStored }
  : { containerSettings: {} };

export const containerSettings = {
  namespaced: true,
  state: initialState,
  actions: {
    setContainerSettings(
      { commit }: any,
      current: { settings: any; index: any }
    ) {
      commit("setContainerSettings", current);
      localStorage.setItem(
        "containerSettingsStored",
        JSON.stringify(this.state.containerSettings.containerSettings)
      );
    },
  },
  mutations: {
    setContainerSettings(state: any, current: any) {
      state.containerSettings[current.index] = current.settings;
    },
  },
};
